import { forwardRef } from "react";

import { ActionIcon } from "@/v2/Buttons";

import Strip from "../Strip";

const BurgerButton = forwardRef(({ onClick, open, height, width, ...props }, ref) => {
  const y = open ? 0 : 8;
  const r = open ? 45 : 0;
  const o = open ? 0 : 100;

  return (
    <ActionIcon
      ref={ref}
      onClick={onClick}
      position="relative"
      data-component-name="BurgerButton"
      size={null}
      bg="dark"
      sx={{
        p: 0,
        height,
        width,
        maxHeight: height,
        maxWidth: width,
        ...props
      }}
    >
      <Strip y={y} r={r} />
      <Strip o={o} />
      <Strip y={-y} r={-r} />
    </ActionIcon>
  );
});

BurgerButton.displayName = "BurgerButton";

export default BurgerButton;
